// extracted by mini-css-extract-plugin
module.exports = {"app-container":"Root_app-container__mFpTA","content-container":"Root_content-container__2Muqu"};